<template>
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block">
                <img
                  src="https://asedino.com/wp-content/uploads/2018/11/lowongan-kerja-paxel-indonesia.jpg"
                  style="width: 100%;height:100%;display:block; position:absolute; object-fit: cover;"
                />
              </div>
              <div class="col-lg-6 purple" style="font-size: 1.3rem;">
                <div class="p-5">
                  <div class="text-center text-white">
                    <h1 class="h4 text-white-900 mb-2">Forgot Your Password?</h1>
                    <p
                      class="mb-4"
                    >We get it, stuff happens. Please enter your email address and we will send the new password so you can log in and reset it by yourself</p>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <input
                        type="email"
                        class="form-control form-control-user"
                        id="exampleInputEmail"
                        v-model="email"
                        aria-describedby="emailHelp"
                        placeholder="Enter Email Address..."
                      />
                    </div>
                    <b-button
                      variant="info"
                      type="submit"
                      :disabled="loading"
                      @click="forgotpass()"
                      class="btn-user btn-block"
                      style="font-size: 1.3rem;"
                    >
                      Reset Password
                      <b-spinner v-if="loading" small label="Loading..."></b-spinner>
                    </b-button>
                  </form>
                  <hr />
                  <!-- <div class="text-center">
                    <router-link
                      :to="{name: 'register'}"
                      class="small text-white"
                    >Make a New Account!</router-link>
                  </div>-->
                  <div class="text-center">
                    <router-link
                      :to="{name: 'login'}"
                      class="small text-white"
                    >Already have an account? Please Login here!</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      email: ""
    };
  },
  methods: {
    forgotpass() {
      this.loading = true;
      const formData = new FormData();
      formData.append("email", this.email);
      this.$store
        .dispatch("forgotpass", formData)
        .then(response => {
          this.loading = false;
          this.$swal({
            type: "success",
            title: "Email recovery password send, check your email",
            showConfirmButton: false,
            timer: 3500
          });
          this.$router.push({ name: "login" });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.serverError = error.response;
          this.password = "";
          this.successMessage = "";
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: #6153a4;
}
</style>
